import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";

const WellnessPage = lazy(() => import("./pages/WellnessPage"));
const WellnessThemePage = lazy(() => import("./pages/WellnessThemePage"));
const DestinationsPage = lazy(() => import("./pages/DestinationsPage"));
const DestinationDetailPage = lazy(() => import("./pages/DestinationDetailPage"));
const ItineraryDetailPage = lazy(() => import("./pages/ItineraryDetailPage"));
const GroupTripsPage = lazy(() => import("./pages/GroupTripsPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/wellness" element={<WellnessPage />} />
            <Route path="/wellness/:themeId" element={<WellnessThemePage />} />
            <Route path="/destinations" element={<DestinationsPage />} />
            <Route path="/destinations/:slug" element={<DestinationDetailPage />} />
            <Route path="/packages/:packageId" element={<ItineraryDetailPage />} />
            <Route path="/slow-travel" element={<GroupTripsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
